//搬出管理
export default [{
  path: '/memberCategory',
  component: () => import('../pages/memberManage/memberCategory.vue'),
  name: 'memberCategory',
  title: "会员卡分类管理",
  meta: {
    title: "会员卡分类管理"
  }
}, {
  path: '/memberManage',

  component: () => import('../pages/memberManage/memberManage.vue'),
  name: 'memberManage',
  title: "会员卡管理",
  meta: {
    title: "会员卡管理"
  }
}, {
  path: '/discountManage',

  component: () => import('../pages/memberManage/discountManage.vue'),
  name: 'discountManage',
  title: "折扣管理",
  meta: {
    title: "折扣管理"
  }
},
  {
    path: '/memberUntie',
    component: () => import('../pages/memberManage/memberUntie.vue'),
    name: 'memberUntie',
    title: "会员卡解绑",
    meta: {
      title: "会员卡解绑"
    }
  }
];
